import React from "react";
import { clsx } from "clsx";

interface IPostEyeCatchProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function PostEyeCatch(props: IPostEyeCatchProps) {
  const { post } = props;

  return (
    <img
      src={post.eyecatch?.url ?? ""}
      alt="eyecatch"
      className={clsx(
        "lg:max-w-3xl",
        "md:max-w-2xl",
        "mb-2",
        "rounded",
        "w-full",
      )}
    />
  );
}
